// Documentos de termos servidos pelo cadastro. A mesma pagina atende o
// formulario do prestador e a WebView do app, que abre /realEstate/termos.
export const termsPages = [
  { slug: 'termos-de-uso', title: 'Termos de Uso' },
  { slug: 'politica-de-privacidade', title: 'Política de Privacidade' },
];

// Publicos que aceitam os termos. Hoje os dois leem o mesmo texto; quando o
// backend passar a servir documentos por publico, cada entrada aqui vira uma
// origem diferente sem que as telas precisem mudar.
export const TERMS_AUDIENCES = ['prestador', 'usuario'];
export const DEFAULT_TERMS_AUDIENCE = 'prestador';

// Conteúdo provisório dos termos exibidos no passo de acesso.
// TODO: trocar por busca na API assim que existir endpoint de termos por company.
// Hoje /v1/terms/getTermRegistration é global (não recebe parâmetro) e
// /v1/terms/GetContractTerm resolve company -> condomínio, o que não atende a
// imobiliária. Este texto é um rascunho e ainda não passou por validação jurídica.
export const termsDocuments = {
  'Termos de Uso': {
    updatedAt: '9 de setembro de 2026',
    sections: [
      {
        heading: '1. Objeto',
        paragraphs: [
          'Estes Termos regulam o cadastro e a atuação de prestadores de serviço na plataforma de manutenção disponibilizada pela administradora responsável pelos imóveis atendidos, doravante denominada Administradora.',
          'Ao concluir o cadastro e marcar a opção de aceite, você declara ter lido, compreendido e concordado integralmente com as condições descritas neste documento.',
        ],
      },
      {
        heading: '2. Cadastro e conta de acesso',
        paragraphs: [
          'O cadastro pode ser realizado por pessoa física ou jurídica, mediante a informação de dados verdadeiros, completos e atualizados. São responsabilidades do prestador:',
        ],
        items: [
          'manter os dados cadastrais atualizados, em especial contato e chave Pix;',
          'zelar pelo sigilo da senha de acesso, que é pessoal e intransferível;',
          'comunicar imediatamente qualquer uso não autorizado de sua conta.',
        ],
      },
      {
        heading: '3. Habilitação e documentação',
        paragraphs: [
          'A ativação do cadastro está condicionada à análise das informações prestadas e da documentação exigida para cada tipo de serviço.',
          'O prestador declara possuir a capacidade técnica, os registros profissionais e as licenças exigidas pela legislação para os serviços que se propõe a executar.',
        ],
      },
      {
        heading: '4. Chamados, propostas e execução',
        paragraphs: [
          'Os chamados são disponibilizados conforme a categoria de serviço, a região de atuação e a disponibilidade do prestador. Aplicam-se as seguintes regras:',
        ],
        items: [
          'o aceite de um chamado é facultativo e não gera exclusividade entre as partes;',
          'prazos, escopo e valores acordados na proposta devem ser cumpridos integralmente;',
          'alterações de escopo devem ser registradas na plataforma antes da execução.',
        ],
      },
      {
        heading: '5. Remuneração e pagamentos',
        paragraphs: [
          'Não há cobrança de taxa de adesão para o cadastro. Os valores devidos são aqueles informados e aceitos em cada proposta.',
          'O pagamento é realizado por Pix, na chave informada no cadastro, após a confirmação da conclusão do serviço e nos prazos divulgados na plataforma. Os tributos incidentes sobre a atividade do prestador são de sua exclusiva responsabilidade.',
        ],
      },
      {
        heading: '6. Relação entre as partes',
        paragraphs: [
          'Estes Termos não criam vínculo empregatício, societário ou de exclusividade entre o prestador e a Administradora.',
          'O prestador é o único responsável pela execução dos serviços, pelos profissionais que emprega e por eventuais danos causados a terceiros durante o atendimento.',
        ],
      },
      {
        heading: '7. Avaliações e qualidade',
        paragraphs: [
          'Os serviços concluídos podem ser avaliados por quem os solicitou. As avaliações compõem o histórico do prestador na plataforma e podem influenciar a distribuição de novos chamados.',
        ],
      },
      {
        heading: '8. Condutas vedadas',
        paragraphs: [
          'É vedado ao prestador, entre outras condutas contrárias à boa-fé:',
        ],
        items: [
          'negociar fora da plataforma serviços originados por meio dela;',
          'utilizar dados de moradores, proprietários ou imóveis para finalidade diversa do atendimento;',
          'apresentar documentos ou informações falsas, adulteradas ou de terceiros;',
          'adotar conduta ofensiva ou discriminatória no contato com solicitantes e equipes.',
        ],
      },
      {
        heading: '9. Suspensão e encerramento',
        paragraphs: [
          'O prestador pode solicitar o encerramento do cadastro a qualquer momento. O descumprimento destes Termos pode ensejar a suspensão ou a exclusão do cadastro, sem prejuízo das obrigações pendentes e das medidas cabíveis.',
        ],
      },
      {
        heading: '10. Alterações destes Termos',
        paragraphs: [
          'Estes Termos podem ser atualizados a qualquer tempo. A versão vigente estará sempre disponível na plataforma e, havendo alteração relevante, um novo aceite poderá ser solicitado.',
        ],
      },
      {
        heading: '11. Disposições finais',
        paragraphs: [
          'Estes Termos são regidos pela legislação brasileira, incluindo o Código de Defesa do Consumidor e a Lei Geral de Proteção de Dados. Fica eleito o foro do domicílio do prestador para dirimir eventuais controvérsias.',
        ],
      },
    ],
  },
  'Política de Privacidade': {
    updatedAt: '9 de setembro de 2026',
    sections: [
      {
        heading: '1. Quem trata os seus dados',
        paragraphs: [
          'A Administradora atua como controladora dos dados pessoais coletados no cadastro de prestadores de serviço, nos termos da Lei nº 13.709/2018 (Lei Geral de Proteção de Dados).',
        ],
      },
      {
        heading: '2. Dados que coletamos',
        paragraphs: [
          'Durante o cadastro e o uso da plataforma são tratadas as seguintes categorias de dados:',
        ],
        items: [
          'identificação: nome completo ou razão social, CPF ou CNPJ, RG e dados do responsável legal;',
          'contato: e-mail, telefone e endereço completo;',
          'profissionais: serviços prestados, tempo de atuação e descrição da atividade;',
          'financeiros: chave Pix informada para recebimento;',
          'de uso: registros de acesso, endereço IP e histórico de chamados e avaliações.',
        ],
      },
      {
        heading: '3. Para que usamos os dados',
        paragraphs: [
          'Cada tratamento tem finalidade específica e base legal correspondente:',
        ],
        items: [
          'criar e manter a sua conta e viabilizar a sua atuação na plataforma — execução de contrato;',
          'validar a identidade e prevenir fraudes — legítimo interesse;',
          'operacionalizar chamados, propostas e pagamentos — execução de contrato;',
          'cumprir obrigações legais, fiscais e regulatórias — cumprimento de obrigação legal;',
          'enviar comunicações sobre novidades e oportunidades — consentimento, revogável a qualquer momento.',
        ],
      },
      {
        heading: '4. Compartilhamento',
        paragraphs: [
          'Os dados podem ser compartilhados com os condomínios e proprietários dos imóveis atendidos, limitados ao necessário para a execução do serviço, com fornecedores de tecnologia e de meios de pagamento, e com autoridades públicas quando houver exigência legal.',
          'Os seus dados não são vendidos nem cedidos para finalidades publicitárias de terceiros.',
        ],
      },
      {
        heading: '5. Armazenamento e retenção',
        paragraphs: [
          'Os dados são armazenados em ambiente controlado e mantidos enquanto o cadastro estiver ativo. Encerrado o cadastro, permanecem apenas pelos prazos legais e prescricionais aplicáveis, sendo posteriormente eliminados ou anonimizados.',
        ],
      },
      {
        heading: '6. Segurança',
        paragraphs: [
          'São adotadas medidas técnicas e administrativas de proteção, como criptografia dos dados em trânsito, controle de acesso por perfil, armazenamento cifrado de senhas e registro das operações realizadas na plataforma.',
        ],
      },
      {
        heading: '7. Seus direitos',
        paragraphs: [
          'Na condição de titular, você pode solicitar a qualquer momento:',
        ],
        items: [
          'a confirmação da existência de tratamento e o acesso aos seus dados;',
          'a correção de dados incompletos, inexatos ou desatualizados;',
          'a anonimização, o bloqueio ou a eliminação de dados desnecessários ou excessivos;',
          'a portabilidade dos dados a outro fornecedor;',
          'a informação sobre com quem os seus dados foram compartilhados;',
          'a revogação do consentimento, quando esta for a base legal aplicável.',
        ],
      },
      {
        heading: '8. Cookies e tecnologias semelhantes',
        paragraphs: [
          'São utilizados cookies estritamente necessários à autenticação e à segurança da navegação. Eles podem ser bloqueados nas configurações do navegador, com possível prejuízo de funcionalidades da plataforma.',
        ],
      },
      {
        heading: '9. Alterações desta Política',
        paragraphs: [
          'Esta Política pode ser atualizada para refletir mudanças legais ou operacionais. A versão vigente estará sempre disponível na plataforma e alterações relevantes serão comunicadas.',
        ],
      },
      {
        heading: '10. Como falar conosco',
        paragraphs: [
          'Solicitações relacionadas a dados pessoais podem ser encaminhadas ao encarregado pelo tratamento de dados por meio dos canais de atendimento indicados pela Administradora.',
        ],
      },
    ],
  },
};

// Enquanto o texto for o mesmo para todo mundo, os dois publicos apontam para o
// mesmo objeto. Trocar por documento proprio e so substituir o valor da chave.
const documentsByAudience = {
  prestador: termsDocuments,
  usuario: termsDocuments,
};

export function findTermsPage(slug) {
  return termsPages.find(page => page.slug === slug);
}

export function getTermsDocument(title, audience) {
  const documents = documentsByAudience[audience] || documentsByAudience[DEFAULT_TERMS_AUDIENCE];

  return documents[title];
}
